// to easily copy and paste components
import React from 'react';
import { withTranslation } from 'react-i18next';
import Parent from '../../common/parent';
import TablesLogic from "../reports/table/tablesLogic";
import MonthsTable from '../reports/table/monthsTable';
import {BllinkLogger} from "../../common/utils/bllink_loggers";
import UploadDownloadToolBar from "./uploadDownloadToolBar";
import { constants } from "../../common/constants/constants";


export class MonthlySettings extends Parent {

    constructor(props) {
        super(props);

        this.onYearsChanged = this.onYearsChanged.bind(this);
        this.onChangeOrLoad.bind(this);
        let initialData = TablesLogic.getInitialData(null, {isPaymentSettings: true});

        this.state = {
            ...initialData,
            ...this.getUploadPaymentState(props),
            title: ''
        }
    }

    async componentDidMount() {
        await this.onChangeOrLoad();
    }

    async onChangeOrLoad(){
        await this.verifyLoggedIn();
        let buildingID = this.props.match.params.buildingID;
        let year = this.props.match.params.year;
        const tableData = TablesLogic.getInitialData(null, {isPaymentSettings: true});
        this.startLoader();
        let rows = await this.getPaymentSettings(buildingID, year);
        const title = await this.buildingTitleText(buildingID);
        // https://sentry.io/organizations/bllink/issues/2493447943/?project=5424386&referrer=RegressionActivityEmail
        // Cannot read properties of undefined (reading 'sort')
        rows = rows || [];
        rows = rows.sort((a,b)=> { return parseInt(a.apartmentName) <  parseInt(b.apartmentName) ? -1 : 1;})
        this.endLoader();

        this.setState({
            ...tableData,
            loaded: true,
            rows: rows,
            currentYear: year,
            title
        });
    }

    async getPaymentSettings(buildingID, year){
        // TODO: use client.managers.paymentSettings.getMonthlySettings(buildingID, year) - AND catch error
        let result = await this.client.get(`/managers/monthly-payment-settings/${buildingID}?year=${year}`);
        BllinkLogger.info(`result payment settings `, result);
        return result[year]
    }

    onYearsChanged(newYear){
        const buildingID = this.props.match.params.buildingID;
        // tried push to history and didn't work
        window.location.href = `/${constants.pages.monthlyPaymentSettings}/${buildingID}/${newYear}`;
    }

    render() {
        const {t} = this.props;
        const buildingID = this.props.match.params.buildingID;
        const year = this.props.match.params.year;
        BllinkLogger.info(`state for monthly settings`, this.state)

        return (
            <div>
                <h1 className='page-title'>
                    {this.state.title && (
                        <span className='building-title'>{this.state.title}</span>
                    )}
                </h1>
                <UploadDownloadToolBar
                    year={year}
                    onYearChanged={this.onYearsChanged}
                    parentState={this.state}
                    buildingID={buildingID}
                />

                <MonthsTable
                    title={t('payment_settings.yearly_payment_settings_title', {year: this.state.currentYear})}
                    rows={this.state.rows}
                    headerNames={this.state.headerNames}
                    tableType={'yearlyByMonths'}
                    excelReportTitle={this.state.excelReportTitle}
                    fields={this.state.rowsFields}
                    showExplanationSection={false}
                    buildingID={buildingID}
                    year={this.state.currentYear}
                />
            </div>
        )
    }
}

export default withTranslation()(MonthlySettings);

